import React from 'react';
import {Table} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";
import FormattedDate from "../../components/formatters/formattedDate";
import Decimal from "../../components/formatters/decimal";
import Currency from "../../components/formatters/currency";

export default class ContractTradesTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell><FormattedDate value={this.props.data.tradeDate}/></Table.Cell>
                <Table.Cell>{this.props.data.periodName || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.loadTypeName || <NoData/>}</Table.Cell>
                <Table.Cell><Decimal value={this.props.data.tradedCapacity}/></Table.Cell>
                <Table.Cell><Decimal value={this.props.data.tradedVolume}/></Table.Cell>
                <Table.Cell><Currency value={this.props.data.tradePrice}/></Table.Cell>
                <Table.Cell><Currency value={this.props.data.tradeValue}/></Table.Cell>
                <Table.Cell>{this.props.data.tradeTypeName || <NoData/>}</Table.Cell>
            </Table.Row>
        );
    }
}